import Items from '../../components/Items/items'
import Schedule from '../../components/schedule/schedule'
import LinksProfileProfessional from '../../components/links-profile/links'
import LinksProfileCompany from '../../components/links-profile-company/links'

export default {
  Items,
  Schedule,
  LinksProfileProfessional,
  LinksProfileCompany
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/gadget/resources/components.js